
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export default function Cookies() {
  const { t } = useTranslation();

  useEffect(() => {
    // 页面加载后自动滚动到顶部
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    // Add JSON-LD structured data
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Cookie Policy - Flidge",
      "description": "Cookie Policy for Flidge game localization platform",
      "url": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/cookies`,
      "isPartOf": {
        "@type": "WebSite",
        "name": "Flidge",
        "url": import.meta.env.VITE_SITE_URL || "https://example.com"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      
      <main className="pt-24 pb-16 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-center">
            {t('cookieTitle')}
          </h1>
          
          <article className="prose prose-invert max-w-none">
            <p className="text-gray-300 text-lg mb-8 text-center">
              {t('cookieLastUpdated')}
            </p>
            
            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('cookie1Title')}</h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('cookie1Content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('cookie2Title')}</h2>
                <p className="text-gray-300 leading-relaxed mb-4">
                  {t('cookie2Content')}
                </p>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-xl font-medium mb-2 text-white">{t('cookie2Essential')}</h3>
                    <p className="text-gray-300 leading-relaxed">
                      {t('cookie2EssentialDesc')}
                    </p>
                  </div>
                  <div>
                    <h3 className="text-xl font-medium mb-2 text-white">{t('cookie2Performance')}</h3>
                    <p className="text-gray-300 leading-relaxed">
                      {t('cookie2PerformanceDesc')}
                    </p>
                  </div>
                  <div>
                    <h3 className="text-xl font-medium mb-2 text-white">{t('cookie2Functional')}</h3>
                    <p className="text-gray-300 leading-relaxed">
                      {t('cookie2FunctionalDesc')}
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('cookie3Title')}</h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('cookie3Content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('cookie4Title')}</h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('cookie4Content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('cookie5Title')}</h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('cookie5Content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('cookie6Title')}</h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('cookie6Content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('cookie7Title')}</h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('cookie7Content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('cookie8Title')}</h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('cookie8Content')}
                </p>
              </section>
            </div>
          </article>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
